import { flowRight } from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Gateway } from 'react-gateway';
import ClickOutside from 'react-click-outside';
import classNames from 'classnames';
import {
  RichContentEditorModal as Modal,
  videoModals,
  imageModals,
  textColorModals,
} from '../rce/rce-editor';
import { connect } from '../../../common/components/runtime-context';
import withCardBackgroundColor from '../../hoc/with-card-background-color';
import withFontClassName from '../../hoc/with-font-class-name';
import createTheme from '../rich-content-editor/theme';

const MODAL_MAP = {
  ...videoModals,
  ...imageModals,
  ...textColorModals,
};

class RichContentEditorModal extends Component {
  render() {
    const theme = createTheme({
      style: this.props.style,
      titleFontClassName: this.props.titleFontClassName,
      contentFontClassName: this.props.contentFontClassName,
    });

    const { modalStyles, ...restModalProps } = this.props.modalProps;
    const modalProps = { ...restModalProps, theme };

    return (
      <Gateway into="rce-modal">
        <div
          style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 99999999999 }}
        >
          <div
            className={classNames('forum-text-color', 'forum-icon-fill')}
            style={modalStyles.overlay}
          >
            <ClickOutside onClickOutside={this.props.onClose}>
              <div
                className="default-forum-card-background-color"
                style={{
                  ...modalStyles.content,
                  backgroundColor: this.props.cardBackgroundColor,
                }}
              >
                <Modal modalsMap={MODAL_MAP} {...modalProps} />
              </div>
            </ClickOutside>
          </div>
        </div>
      </Gateway>
    );
  }
}

RichContentEditorModal.propTypes = {
  modalProps: PropTypes.object,
  onClose: PropTypes.func,
  cardBackgroundColor: PropTypes.string,
  style: PropTypes.object,
  titleFontClassName: PropTypes.string,
  contentFontClassName: PropTypes.string,
};

const mapRuntimeToProps = (state, ownProps, actions, host) => ({
  style: host.style,
});

export default flowRight(
  connect(mapRuntimeToProps),
  withCardBackgroundColor,
  withFontClassName,
)(RichContentEditorModal);
